import API from "./api";
import router from "@/router";

export default {
  fetchObservations() {
    return API().get("observations");
  },
  addObservation(params) {
    return API().post("observations", params);
  },
  updateObservation(params) {
    return API().put(
      `observations/observation/${router.currentRoute.params.id}`,
      params
    );
  },
  fetchObservation() {
    return API().get(
      `observations/observation/${router.currentRoute.params.id}`
    );
  },
  fetchStudentRegisterObservation(uuid) {
    return API().get(`student-register/${uuid}`);
  },
  fetchMediaObservation(uuid) {
    return API().get(`media/observation/${uuid}`);
  },
};
